import React, { useState, useEffect, useRef } from "react";

import { toast } from "react-toastify";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import { ModalTitle, FormField } from "../QueueIntegrationModal/panelKit";

const FlowBuilderTicketModal = ({ open, onSave, data, onUpdate, close }) => {
  const isMounted = useRef(true);

  const initialState = {
    queue: "",
    user: "",
  };

  const [activeModal, setActiveModal] = useState(false);
  const [queues, setQueues] = useState([]);
  const [selectedQueue, setQueueSelected] = useState();

  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState();

  useEffect(() => {
    if (open === "edit") {
      (async () => {
        try {
          // console.log("data: ", data);
          const queue = data.data.queue;
          const user = data.data.user;

          const { data: old } = await api.get("/queue");
          const { data: result } = await api.get("/users");

          setUsers(result.users);
          setQueues(old);

          setQueueSelected(queue.id);
          setSelectedUser(user.id);

          setActiveModal(true);
        } catch (error) {
          console.log(error);
        }
      })();
    } else if (open === "create") {
      (async () => {
        try {
          const { data } = await api.get("/queue");
          const { data: result } = await api.get("/users");
          setUsers(result.users);
          setQueues(data);
          setSelectedUser("");
          setQueueSelected("");
          setActiveModal(true);
        } catch (error) {
          console.log(error);
        }
      })();
    }
    return () => {
      isMounted.current = false;
    };
  }, [open]);

  const handleClose = () => {
    close(null);
    setActiveModal(false);
  };

  const handleSaveContact = () => {
    if (!selectedQueue) {
      return toast.error("Adicione uma fila");
    }
    if (open === "edit") {
      const queue = queues.find((item) => item.id === selectedQueue);
      const user = users.find((item) => item.id === selectedUser);

      onUpdate({
        ...data,
        data: {
          queue: queue ? queue : "",
          user: user ? user : "",
        },
      });
    } else if (open === "create") {
      const queue = queues.find((item) => item.id === selectedQueue);
      const user = users.find((item) => item.id === selectedUser);

      onSave({
        queue: queue ? queue : "",
        user: user ? user : "",
      });
    }
    handleClose();
  };

  return (
    <Dialog
      open={activeModal}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      scroll="paper"
    >
      <ModalTitle
        id="form-dialog-title"
        title={open === "create" ? `Adicionar uma fila ao fluxo` : `Editar fila`}
        subtitle="Transfere a conversa para uma fila quando o fluxo chega neste ponto."
        onClose={handleClose}
      />
      <DialogContent>
        <FormField label="Escolha a fila que deseja transferir">
          <FormControl variant="outlined" size="small" fullWidth>
            <Select
              id="flow-ticket-queue-select"
              value={selectedQueue}
              displayEmpty
              onChange={(e) => {
                setQueueSelected(e.target.value);
              }}
              MenuProps={{
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "left",
                },
                getContentAnchorEl: null,
              }}
              renderValue={() => {
                if (selectedQueue === "") {
                  return "Selecione uma Conexão";
                }
                const queue = queues.find((w) => w.id === selectedQueue);
                return queue ? queue.name : "Selecione uma Conexão";
              }}
            >
              {queues.length > 0 &&
                queues.map((queue, index) => (
                  <MenuItem dense key={index} value={queue.id}>
                    {queue.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </FormField>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>
          {i18n.t("contactModal.buttons.cancel")}
        </Button>
        <Button
          type="submit"
          color="primary"
          variant="contained"
          onClick={handleSaveContact}
        >
          {open === "create" ? `Adicionar` : "Editar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FlowBuilderTicketModal;
